/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioGroupComponent from '../../../../../../SharedModules/RadioGroup/RadioGroupBtn';

import NDCByDrugName from '../../../../../Display/NDC/component/NDCByDrugName/NDCByDrugName';
import NDCByID from '../../../../../Display/NDC/component/NDCByID/NDCByID';
import NDCByLabeler from '../../../../../Display/NDC/component/NDCByLabeler/NDCByLabeler';
import {
  getAllNDCReferenceData,
  setNDCSelectedNDCTab,
} from '../../../../../Display/NDC/store/action';
import { NDC_TABS_DATA } from '../utils/constant';

const RequestedPreviousNDCTabs = ({
  setErrorMessages,
  fullScreen,
  setFullScreen,
}) => {
  const dispatch = useDispatch();
  const selectedNDCTab = useSelector(
    (state) => state.sharedState.ndc.selectedNDCTab
  );
  const ndcSearchError = useSelector(
    (state) => state.sharedState.ndc.errorPopupMessage
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const searchScrErr = useSelector(
    (state) => state?.sharedState?.requestedPreviousClaim.searchScrErr
  );
  useEffect(() => {
    dispatch(getAllNDCReferenceData());
  }, []);
  useEffect(() => {
    if (ndcSearchError && ndcSearchError != '')
      setErrorMessages([...searchScrErr, ndcSearchError]);
  }, [ndcSearchError]);

  useEffect(() => {
    if (userDefaults && userDefaults.defNdcSelectModeCd) {
      dispatch(
        setNDCSelectedNDCTab(
          NDC_TABS_DATA[
            userDefaults.defNdcSelectModeCd === 'NDC'
              ? 0
              : userDefaults.defNdcSelectModeCd === 'LABELER'
              ? 2
              : 1
          ].value
        )
      );
    } else {
      dispatch(setNDCSelectedNDCTab(NDC_TABS_DATA[1].value));
    }
  }, [userDefaults]);

  const onNDCTypeChange = (type) => {
    dispatch(setNDCSelectedNDCTab(type));
  };

  return (
    <>
      <div className="tabs-container p-0">
        {!fullScreen && (
          <div className="mui-custom-form col-12 m-0 p-0">
            <RadioGroupComponent
              labelName="Search Type"
              id="ndcSearchTypeType"
              data-testid="ndcSearchTypeType"
              optionList={NDC_TABS_DATA}
              defaultValue={selectedNDCTab}
              filterAction={onNDCTypeChange}
            />
          </div>
        )}
        {selectedNDCTab === NDC_TABS_DATA[0].value ? (
          <NDCByID
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            isViewNDCHidden
          />
        ) : selectedNDCTab === NDC_TABS_DATA[1].value ? (
          <NDCByDrugName
            isViewNDCHidden
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : (
          <NDCByLabeler
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            isViewNDCHidden
          />
        )}
      </div>
    </>
  );
};

export default RequestedPreviousNDCTabs;
